import { render, staticRenderFns } from "./SettingsServer.vue?vue&type=template&id=9f6084b6"
import script from "./SettingsServer.vue?vue&type=script&lang=js"
export * from "./SettingsServer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports